<!-- Scanner itself -->
<ngx-scanner-qrcode #scanner="scanner"
                    [class.hidden]="hasError"
                    [config]="config"
                    [fps]="2"
                    [isBeep]="false"
                    (event)="onScan($event)">
</ngx-scanner-qrcode>

<!-- SVG corners overlay -->
@if (!hasError) {
  <div class="fancy-overlay absolute-overlay">
    @for (corner of fancyCorners; track corner) {
      <svg [ngClass]="corner.ngClass"
           width="40"
           height="40"
           viewBox="0 0 40 40"
           [style.transform]="'rotate(' + corner.rotate + ')'"
           [ngStyle]="corner.position">
        <path d="M 5 35 L 5 5 L 35 5"/>
      </svg>
    }
  </div>
}

<!-- Scanner errors -->
@if (hasError) {
  <div class="error-overlay absolute-overlay flex-center column">

    <app-icon
      [faIcon]="['fas', 'exclamation']"
      bgColor="failure">
    </app-icon>

    <div class="error-message font-bold push-top pad-left pad-right">
      @switch (status) {
        @case ('no_cameras') {
          {{ 'common.qrcode_scanner.errors.no_cameras' | translate }}
        }
        @case ('no_permissions') {
          {{ 'common.qrcode_scanner.errors.no_permissions' | translate }}
        }
      }
    </div>
  </div>
}
